import * as React from 'react'
import Button from '@mui/material/Button'
import styled from '@emotion/styled'
import { MuiButtonInterfaceProps } from '@Interfaces/Component/ButtonInterfaces'

const VisuallyHiddenInput = styled('input')({
  height: 1,
  width: 1,
  overflow: 'hidden',
})

const MuiButton: React.FC<MuiButtonInterfaceProps> = ({
  title,
  sx,
  onPress,
  variant,
  color,
  type,
  onChange,
  accept,
  loading,
  disabled,
  ...props
}) => {
  return (
    <Button
      onClick={onPress}
      disableElevation
      component={type === 'file' ? 'label' : 'button'}
      disabled={loading || disabled}
      sx={{
        borderRadius: '20px',
        textTransform: 'none',
        fontWeight: 900,
        fontSize: 16,
        fontFamily: 'Montserrat',
        borderWidth: 1,
        paddingY: 3,
        paddingX: 20,
        '&.MuiButton-contained.Mui-disabled': {
          opacity: 0.5,
          bgcolor: `${[color || 'primary']}.main`,
          color: `${[color || 'primary']}.contrastText`,
        },
        ...sx,
      }}
      {...{ variant, color, ...props }}
    >
      {loading ? 'Loading...' : title}

      {type === 'file' && (
        <VisuallyHiddenInput
          type="file"
          onChange={(e) => {
            const reader = new FileReader()
            reader.addEventListener('load', () => {
              const file = e.target.files?.[0]
              if (file) {
                const out = file as File & { url?: string }
                out.url = reader.result?.toString()
                onChange?.(out)
              }
            })
            if (e.target.files?.[0]) {
              reader.readAsDataURL(e.target.files[0])
            }
          }}
          accept={accept || '.jpg, .png'}
        />
      )}
    </Button>
  )
}

export default React.memo(MuiButton)
